<template>
    <div class="register__sub-navigation">
        <div class="flex line">
            <div class="w-1/6"></div>
            <div :class="leftLineClass"></div>
            <div :class="leftLineClass"></div>
            <div :class="rightLineClass"></div>
            <div :class="rightLineClass"></div>
            <div class="w-1/6"></div>
        </div>

        <div class="flex icons">
            <div class="w-1/3 introductions">
                <router-link :to="{ name: accountRouteName }" :class="introductionsClass">
                    <div class="icon introductions"></div>
                    <span v-html="$t('REGISTER_SUB_NAVIGATION_INTRODUCTIONS')"></span>
                </router-link>
            </div>

            <div class="w-1/3 delivery">
                <router-link :to="{ name: deliveryRouteName }" :class="deliveryClass" :event="deliveryRouteLinkEvent">
                    <div class="icon delivery"></div>
                    <span v-html="$t('REGISTER_SUB_NAVIGATION_DELIVERY')"></span>
                </router-link>
            </div>

            <div class="w-1/3 card-details">
                <router-link :to="{ name: cardDetailsRouteName }" :class="cardDetailsClass" :event="''">
                    <div class="icon card-details"></div>
                    <span v-html="$t('REGISTER_SUB_NAVIGATION_CARD_DETAILS')"></span>
                </router-link>
            </div>
        </div>

        <div class="w-auto pt-5 pb-0" v-if="showCanvasserOptions">
            <!-- Example page url -->
            <div class="text-center">
                <a :href="pdfReference" target="_blank" class="link text-blue-600">Example Account Page</a>
                <span class="px-2">/</span>
                <router-link :to="{ name: accountRouteName }" :class="introductionsClass">
                    <a @click="resetRegistrationProgress" href="#" class="link text-blue-600">Reset Registration</a>
                </router-link>
                <span class="or">/</span>
                <router-link v-if="this.isInCanvassingMode" :to="{ name: 'canvasser-register.restart-account' }" :class="introductionsClass">
                    <a class="link text-blue-600">Restart</a>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { CANVASSER_TYPE } from '@/constants/Account';

export default {
    data() {
        return {
            pdfReference: '/example_page.pdf',
        };
    },
    computed: {
        ...mapGetters({
            showCanvasserOptions: 'auth/isCanvasser',
        }),
        accountRouteName() {
            return this.isInCanvassingMode ? 'canvasser-register.account' : 'register.account';
        },
        deliveryRouteName() {
            return this.isInCanvassingMode ? 'canvasser-register.delivery' : 'register.delivery';
        },
        cardDetailsRouteName() {
            return this.isInCanvassingMode ? 'canvasser-register.card-details' : 'register.card-details';
        },
        deliveryRouteLinkEvent() {
            return this.$route.name.includes('register.card-details') ? 'click' : '';
        },
        introductionsClass() {
            return {
                active: this.$route.name.includes('register.account'),
                past: !this.$route.name.includes('register.account'),
            };
        },
        deliveryClass() {
            return {
                active: this.$route.name.includes('register.delivery'),
                past: this.$route.name.includes('register.card-details'),
            };
        },
        cardDetailsClass() {
            return {
                active: this.$route.name.includes('register.card-details'),
            };
        },
        leftLineClass() {
            return {
                dark: !this.$route.name.includes('register.account'),
                'w-1/6': true,
            };
        },
        rightLineClass() {
            return {
                dark: this.$route.name.includes('register.card-details'),
                'w-1/6': true,
            };
        },
        isInCanvassingMode() {
            return process.env.VUE_APP_MODE === CANVASSER_TYPE;
        },
    },
    methods: {
        resetRegistrationProgress() {
            this.$store.commit('register/resetState');
        },
    },
};
</script>
